// extracted by mini-css-extract-plugin
export default {"dropdown":"LgCngSTsqc4dN9BNN9rz"};